<template>
  <section class="serviceDetail">
    <header-com />
    <div class="banner">
      <home-swiper :imgList='specificationList[selectSpecificationIndex].curingServiceImagesBoList'/>
    </div>
    <div class="hGroup">
      <h2 class="f32 bold">{{detail.name}} <span class="r">￥<i class="f36">{{specificationList[selectSpecificationIndex].price}}</i></span></h2>
      <h3 class="f24 grey9">{{detail.content}}</h3>
      <div class="soldWrap">
        <div class="f26 grey9 sold">已售 {{specificationList[selectSpecificationIndex].salesNumber}}</div>
        <num-count :num="num"
            @minus = 'num > 1 ? num-- : num = 1'
            v-if='specificationList[selectSpecificationIndex].classify == 10'
            @plus="num++"/>
      </div>
    </div>
    <div class="line"></div>
    <div class="specification">
      <div class="l">规格</div>
      <ul>
        <li v-for="(item,index) in specificationList"
            :key="index"
            :class="{'active':(selectSpecificationIndex === index)}"
            @click="setIndex(index,item.name)">{{item.name}}</li>
      </ul>
    </div>

    <!-- <teamInfo 
      v-show='specificationList[selectSpecificationIndex].classify == 30 && specificationList[selectSpecificationIndex].groupActivityBo.isShowGroup && showTeamInfo && canTeam'
      v-if='specificationList[selectSpecificationIndex].classify == 30'
      :team='specificationList[selectSpecificationIndex]'
      @nolist='showTeamInfo = false'
      ref='teamInfos'
    >

    </teamInfo> -->

    <div class="navWrap clearfix" v-if='specificationList[selectSpecificationIndex].classify == 10'>
      <tabCom :tabData="tabData"
              :activeIndex="activeIndex"
              @changeTab="changeTab"
              :tabFlag='tabFlag[selectSpecificationIndex]'
              />
    </div>

    <!--内容区-->
    <section class="content">
      <!--服务介绍-->
      <service-introduction v-show="activeIndex === 0" :serviceIntroduction="specificationList[selectSpecificationIndex].curingServiceContentBoList"></service-introduction>
      <!--案例库-->
      <case-base v-if="activeIndex === 1" :categoryId='detail.categoryId' :serviceId='serviceId + ""' :sid='specificationList[selectSpecificationIndex].id'></case-base>
      <!--工艺标准-->
      <!-- <technological v-if="activeIndex === 2" :navDatas='specificationList[selectSpecificationIndex].curingServiceContentBoList'></technological> -->
      <section class="technological" v-if="activeIndex === 2">    
        <van-tabs background="#f8f8f8" color="#7ADFDF" title-inactive-color="#999" title-active-color="#333" swipeable v-model="active">
          <van-tab v-for="(item,index) in specificationList[selectSpecificationIndex].curingServiceContentBoList" :key="index" :title="item.blockName" v-if='item.type==20'>
            <div class="content">
              <div v-if='item.blockPic'>
                <img align="middle" :key="index" style='width:100%' v-for='(data,index) in JSON.parse(item.blockPic)' :src="formatImgUrl(data,2400,2300,true)" />
              </div>
              <div v-else v-html="item.blockContent"></div>
            </div>
          </van-tab>
        </van-tabs>
      </section>
    </section>
    <div class='cot_down_time' :class='{cotDownI : isIPX}' v-if='specificationList[selectSpecificationIndex].classify == 30'>
      <downTime
          :state='detail.curingServiceWithContentAndImagesBoList[0].groupActivityBo.status'
          :times='downTimesTag'
          v-if='downTimesTag && (detail.curingServiceWithContentAndImagesBoList[0].groupActivityBo.status != 30 && detail.curingServiceWithContentAndImagesBoList[0].groupActivityBo.status != 40)'
          :sizeTag='true'
          @timeEnd='timeEnd'
      ></downTime>
      <div v-else>该活动已结束</div>
    </div>
    <div class="g-fixed-bottom">
      <div @click='toHomeIndex' class='homeBtn'>
        <img src="/images/home/home_icon.png" align="middle"/>
        <p>首页</p>
      </div>
      <div class='bagit_cont' @click='lookBag' v-if='specificationList[selectSpecificationIndex].classify == 10'>
        <img src="/images/home/gouwu_icon.png" align="middle"/>
        <p>方案</p>
        <span class='bagit' v-if='bagNum'>{{bagNum}}</span>
      </div>
      <button class="secondary" @click="addGoodsBag()" v-if='specificationList[selectSpecificationIndex].classify == 10'>加入方案袋</button>

      <button class="primary" @click="enoughBuy()" v-if='specificationList[selectSpecificationIndex].classify != 30'>立即购买</button>

      <button class="primary"  :disabled='specificationList[selectSpecificationIndex].groupActivityBo.status != 20' :class='{disableBtn:!canTeam}' @click="enoughBuy()" v-if='specificationList[selectSpecificationIndex].classify == 30'>
        发起拼团
      </button>
    </div>
    <!-- <div class="kefu-fix" :class="{scrolling:scrollFlag}">
      <div style="float:left;width:70%;margin-top:40px">
          <div class="kefu-dis asc-line" v-if="isTis">
              <span> 有任何不明白的地方就来问我吧</span>
          </div>
      </div>
      <div style="float:right;width:20%;padding-left: 10px;" ref="shopBag" >
          <div  id="alldo" style="position:absolute;width:150px;height:150px;z-index:999;"></div>
          <img src="/images/home/kefu-1.png" style="width:42px;height:48px;position:absolute;margin-top:10px;margin-left:3px" class="kefu-baoblack" alt="">
          <img src="/images/home/kefu-2.png" style="width:56px;height:31px;position:absolute;margin-top: 43px;" class="kefu-ad" alt="">
      </div>
    </div> -->
  </section>
</template>

<script>
  import ServiceIntroduction from './serviceIntroduction'
  import CaseBase from './caseBase'
  import Technological from './technological'
  import homeApi from '@/axios/home'
  import wxShare from "@/assets/js/wx.share"
  import { setTimeout } from 'timers';
  import zhugeObj from '@/assets/js/track'
  import publicObj from '@/assets/js/public';
  import { Dialog } from 'vant';
  import { Toast } from 'vant';
  import getWXConfig from "@/assets/js/wx.config";
  import $ from 'jquery'

  
  var timerout;
  export default {
    name: 'serviceDetail',
    components: { Technological, CaseBase, ServiceIntroduction },
    data () {
      return {
        bagNum : 0,
        tabFlag : {},
        active : 0,
        serviceId : '',
        showTeamInfo : true,
        num: 1,
        selectSpecificationIndex: 0,
        scrollFlag: false,
        specificationList: [{
          salesNumber : 0,
          groupActivityBo : {}
        }],
        activeIndex: 0,
        tabData: [
          { name: '服务介绍' },
          { name: '案例库' },
          { name: '工艺标准' }
        ],
        serviceIntroduction: [
          {
            title: '尺寸说明',
            content: '<img src="https://img.yzcdn.cn/public_files/2017/09/05/3bd347e44233a868c99cf0fe560232be.jpg"/>'
          },
          {
            title: '服务说明',
            content: '<img src="https://img.yzcdn.cn/public_files/2017/09/05/3bd347e44233a868c99cf0fe560232be.jpg"/>'
          }
        ],
        detail : {},
        isIPX:false,
        downTimesTag : null,
        canTeam : true,
        canTeamMes : '',
        scrollTag : false,
        isTis:true,
      }
    },
    watch: {

    },
    computed: {
      
    },
    created () {
      this.isIPX=publicObj.isIPX()
      this.serviceId = this.$route.query.serviceId;
      //获取服务详细信息
      this.getDetail(this.serviceId);
      this.getShoppingCart();
      this.onscroll();
      if(this.serviceId==93){
        zhugeObj.track({
          title : '详情页-拼团服务-曝光'
        })
      }
    },
    mounted () {
      if(localStorage.isKeFuShow){
        this.isTis = false
        setTimeout(()=>{
          $(window).bind('scroll',()=>{
            this.menu()
          });
        },1000)
      }else{
        setTimeout(()=>{
          $(window).bind('scroll',()=>{
            this.menu()
          });
          localStorage.isKeFuShow = 1
        },4000)
      }
      getWXConfig()
      this.addBuytton()      
    },
    methods: {     
      addBuytton(){
        console.log(this.detail.name)
      },
      onscroll(){
        
        window.addEventListener('scroll',()=>{
          if(!this.scrollTag){
            zhugeObj.track({
              title : '查看服务详情-曝光',
              content : {
                '服务名称' : this.detail.name,
                '服务分类' : this.detail.categoryId,
              }
            })
            this.scrollTag = true;
          }else{
            window.removeEventListener('scroll',()=>{})
          }
          
        })
      },
      menu() {
          let _this = this;
          this.scrollFlag = true;
          if (timerout) {
              window.clearTimeout(timerout);
          }
          timerout = window.setTimeout(() => {
              this.scrollFlag = false
          }, 500);
      },
      teamOpenVerify(cid){
          if(!this.$store.state.token){
            return;
          }
          homeApi.teamOpenVerify(cid).then((res)=>{
        
          }).catch((data)=>{
              this.canTeam = false;
              this.canTeamMes = data.message
          })

      },

      timeEnd(){


        this.$refs.teamInfos.getList();
        
        this.getDetail(this.serviceId);
      },
      lookBag(){
        zhugeObj.track({
            title : '点击-服务详情方案'
        })
        this.$router.push({ name: "homeBag" });
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      getShoppingCart(){
        homeApi.shoppingCartcount().then((res)=>{
          this.bagNum = res.buyQuantity;
        })
      },
      toHomeIndex(){
      zhugeObj.track({
            title : '点击-服务详情首页'
          })
        this.$router.push({name:'homeIndex'});
      },
      setIndex(index,name){

          zhugeObj.track({
            title : '查看服务详情',
            content : {
              '服务项名称':name,
              '数量' : this.num

            }
          })
          this.selectSpecificationIndex = index;
          this.activeIndex = 0;
      },  
      changeTab (index) {
        if(index == 0){
          zhugeObj.track({
            title : '查看服务详情',
            content : {
              '服务介绍':'服务介绍',

            }
          })
        }else if(index == 1){
          zhugeObj.track({
            title : '查看服务详情',
            content : {
              '案例库' : '案例库'

            }
          })
        }else{
          zhugeObj.track({
            title : '查看服务详情',
            content : {
              '工艺标准' : '工艺标准'
            }
          })
        }

        this.activeIndex = index;
      },
      getDetail(id){
          homeApi.serviceDetail(id).then((res)=>{
            this.detail = res;

            zhugeObj.track({
              title : '查看服务详情',
              content : {
                '服务名称' : res.name,
                '服务分类' : res.categoryId
              }
            })
            

            if(res.curingServiceWithContentAndImagesBoList[0].classify == 30 && res.curingServiceWithContentAndImagesBoList[0].groupActivityBo.status == 20){
              this.downTimesTag = res.curingServiceWithContentAndImagesBoList[0].groupActivityBo.countDownEnd;
              this.teamOpenVerify(res.curingServiceWithContentAndImagesBoList[0].id)
            }else if(res.curingServiceWithContentAndImagesBoList[0].classify == 30 && res.curingServiceWithContentAndImagesBoList[0].groupActivityBo.status == 10){
              this.downTimesTag = res.curingServiceWithContentAndImagesBoList[0].groupActivityBo.countDownBegin;
            }

            
            this.specificationList = res.curingServiceWithContentAndImagesBoList;
            const specificationId = this.$route.query.specificationId
    
            this.specificationList.forEach((item,index)=>{
              if(item.id == specificationId){
                this.selectSpecificationIndex = index;
       
                
              } 
            })
            //判断是否存在工艺标准，显示头部tab
            this.tabFlag = {}
            res.curingServiceWithContentAndImagesBoList.forEach((element,index)=>{
              this.tabFlag[index] = false
              element.curingServiceContentBoList.forEach(item=>{
                if(item.type == 20){
                  this.tabFlag[index] = true
                }
              })
            });
            if(id==95){
              setTimeout(()=>{
                let shareBody = {
                  desc: "10位朋友已读",
                  title: "香奈儿免费送！！快上车！！",
                  // imgUrl : this.formatImgUrl(res.curingServiceWithContentAndImagesBoList[0].curingServiceImagesBoList[0].pic,1000,1000,true),
                  imgUrl:'https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/img/WechatIMG214.jpeg',
                  link : window.location.href + '&utm_source=ljfx-xqy'
                }; 
                wxShare(shareBody);
              },1000)
            }else{
              setTimeout(()=>{
                let shareBody = {
                  desc : '打理心爱之物',
                  title : res.name + '工艺升级！喊你来开眼界和洗包啦！',
                  imgUrl : this.formatImgUrl(res.curingServiceWithContentAndImagesBoList[0].curingServiceImagesBoList[0].pic,1000,1000,true),
                  // imgUrl:'https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/img/WechatIMG214.jpeg',
                  // link : window.location.href + '&utm_source=ljfx-xqy'
                   link : window.location.href 
                  //ink:'https://mi.baozheng.cc/serviceDetail?serviceId=95'
                }; 
                wxShare(shareBody);
              },1000)
            }
          })
      },
      async enoughBuy(){
        if(this.serviceId==93){
          zhugeObj.track({
              title : '详情页-拼团立即开团按钮-点击'
          })
        }
        
        if(!this.canTeam){
          Toast(this.canTeamMes);
          return;
        }
        // alert(12)
        zhugeObj.track({
          title : '点击-立即购买',
          content : {
            '规格' : this.specificationList[this.selectSpecificationIndex].name,
            '数量' : this.num
          }
        })

        if(this.specificationList[this.selectSpecificationIndex].classify == 20){
          let paramsActive = {
              remarks : '',
              action : 'normal',
              categoryRemark : '[{"id":3,"count":0},{"id":4,"count":0},{"id":5,"count":0},{"id":6,"count":0},{"id":87,"count":1}]',

          };
          
          paramsActive.curingServiceId = this.specificationList[this.selectSpecificationIndex].id;
          paramsActive.buyQuantity = this.num;
          homeApi.submitCart(paramsActive).then((res)=>{
           
            this.$router.push({name:'pay',query:{id:res.orderCode,type:'active'}})
           
          })
          return;
        }

        if(this.specificationList[this.selectSpecificationIndex].classify == 30){
          zhugeObj.track({
              title : '自选下单——发起拼团',
              content : {
                  '位置' : '服务详情页'
              }
          })

          let params1 = {
            action : 'normal'
          }
          params1.curingServiceId = this.specificationList[this.selectSpecificationIndex].id;
          params1.buyQuantity = this.num;
          if(this.teamId){
            params1.groupRecordId = this.teamId;
          }
   
          let tag = await publicObj.validationTeam(params1);
        
          if(!tag){
            return;
          }

          let paramsActive = {
              remarks : '',
              action : 'normal',
              categoryRemark : '[{"id":3,"count":0},{"id":4,"count":0},{"id":5,"count":0},{"id":6,"count":0},{"id":87,"count":1}]',

          };
          
          paramsActive.curingServiceId = this.specificationList[this.selectSpecificationIndex].id;
          paramsActive.buyQuantity = this.num;
          homeApi.submitCart(paramsActive).then((res)=>{
             this.$router.push({name:'pay',query:{id:res.orderCode,type:'active',isTeam:true}})
            // this.$router.push({name:'homeBag',query:{curingServiceId:this.specificationList[this.selectSpecificationIndex].id,buyQuantity:this.num,isTeam:'1'}})
           
          })



          
          return;
        }
       
       
        this.$router.push({name:'homeBag',query:{curingServiceId:this.specificationList[this.selectSpecificationIndex].id,buyQuantity:this.num}})
      },
      addGoodsBag(){
        let params = {
          curingServiceId : this.specificationList[this.selectSpecificationIndex].id,
          buyQuantity : this.num,
          curingServiceGoodsId : this.serviceId,
          categoryId : this.detail.categoryId
        }
        zhugeObj.track({
          title : '点击-加入方案袋',
          content : {
            '规格' : this.specificationList[this.selectSpecificationIndex].name,
            '数量' : this.num
          }
        })
        homeApi.shoppingCart(params).then((res)=>{
          this.bagNum = res.buyQuantity;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

.kefu-fix{
        width:500px;
        height:150px;
        // background-color: #7ADFDF;
        position: fixed;
        right: 0;
        bottom: 200px;
        right: 0 !important;
        transition: all 0.5s ease;
        -webkit-transition: all 0.5s ease;
    }
    .asc-line{
        width:0;
        height:60px;
        position:relative;
        background:#000000;
        color:#fff;
        white-space: nowrap;
        overflow: hidden;
        line-height: 60px;
        text-align: center;
        top: -14px;
        border-top-left-radius:25px;
        border-bottom-right-radius:25px;
        border-bottom-left-radius:25px;
    }
    .kefu-dis{
        animation:myfirst 5s;
        animation-delay:1s;
    }
    .kefu-ad{
        animation:mytwo .5s;
    }
    .kefu-baoblack{
        animation:mythree 1s;
    }
    @keyframes myfirst
    {
        0%   {left:385px;width:0}
        20%   {left:0px;width:384px}
        80%  {left:0px;width:384px}
        100%  {left:385px;width:0}
    }
    @keyframes mytwo
    {
        from {transform:scale(.1);}
        to {transform:scale(1);}
    }
    @keyframes mythree
    {
        0%   {margin-top: 48px}
        90%  {margin-top: 10px}
    }
    .scrolling {
        right: -63px !important;
        transition: all 0.5s ease;
        -webkit-transition: all 0.5s ease;
    }
.disableBtn{
  background: #CCCCCC!important;
  color: #fff!important;
}
.countDown{
    position:relative;
    // top:1px;
}
.cotDownI{
  bottom:128px!important;
}
.cot_down_time{
  width: 100%;
  height: 88px;
  background: #6AA0A4;
  position: fixed;
  bottom:108px;
  left:0;
  opacity:0.9;
  color:#fff;
  font-size: 32px!important;
  text-align: center;
  line-height: 88px;
  
}
.homeBtn{
  width: 60px!important;
  flex-grow: initial!important;
  flex-shrink: initial!important;
  flex-basis: initial!important;

}
.bagit_cont{
  position: relative;
}
.bagit{
  width: 30px;
  height: 30px;
  display: block;
  position:absolute;
  z-index: 99;
  background: #F24949;
  color:#fff;
  border-radius:50%;
  top:2px;
  right: 2px; 
  line-height: 30px;
  text-align: center;
}
.secondary{
  margin-right:15px;
}
.technological{
  .van-tab__pane{
    padding-top: 90px;
  }
  .content{
    width:100%;
    text-align: center;
    padding-bottom: 130px;
    img{max-width: 100%}
  }
}
.serviceDetail{
  .banner{
    // background: #eee;
    height: 500px;
  }
  /*商品信息区*/
  .hGroup{
    padding:40px 30px 38px;
    h2{
      line-height: 44px;
      margin-bottom: 20px;
    }
    h3{
      line-height: 34px;
      // margin-bottom: 24px;
    }
    .soldWrap{
      display: flex;
      line-height: 46px;
      justify-content: space-between;
      margin-top:50px;
      .sold{
        padding-left: 42px;
        line-height: 50px;
        background: url("/images/home/service_detail_icon01.png") no-repeat left 25%;
        background-size: 32px;
      }
    }
  }
  /*规格*/
  .specification{
    padding:36px 0 16px 30px ;
    border-bottom:20px #F6F6F6 solid;
    div{
      line-height: 54px;
    }
    ul{
      margin-left: 88px;
      display: flex;
      flex-wrap: wrap;
      li{
        min-width:138px;
        height:54px;
        line-height: 52px;
        box-sizing: border-box;
        padding: 0 20px;
        background:#f8f8f8;
        border-radius:6px;
        border:$base-border;
        text-align: center;
        margin: 0 20px 20px 0;
      }
      .active{
        border-color: $brand-color;
        color: #000;
        background: rgba($brand-color,.1);
      }
    }
  }
  /*导航区*/
  .navWrap{
    padding: 22px 0;
    position: relative;
  }
  /*内容区*/
  .content{
    // padding-bottom: 100px;
  }
  .g-fixed-bottom{
    display: flex;
    justify-content: space-between;
    align-items:center;
    padding-top: 0;
    >div{
      width: 80px;margin-right: 50px;
      text-align: center;
      img{
        width: 52px;
        margin-bottom: 6px;
      }
      p{
        line-height: 28px;
        font-size: 20px;
      }
    }
  }
}
</style>
